<template>
  <ob-modal2 :show.sync="ShowSharePopup" :backdrop="false" width="630px">
    <template slot="modal-title">
        Share Timesheets
    </template>
    <template slot="modal-body">
        <div class="row form-group ">
            <div class="col-md-12">
                <span style="color: #337ab7;font-weight: 700;">Select approved timesheets to share.</span>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-12">
                <ob-select2 v-if="showOptions" :inModal="true" :options="TimesheetListOptions" @input="onSelectTimesheet()" :multiple="true" v-model="SelectedTimesheet" :class="{ 'ob-vuelidate_input-error': IsSelectTimesheetError && IsButtonClicked }"></ob-select2>
                 <h3 v-if="!IsApprovedYimesheetsAvailable" style="color:#F07431">No approved timesheets available for the candidate.</h3>
                <span  class="ob-vuelidate_error-msg" v-if="IsSelectTimesheetError && IsButtonClicked">Please select</span>
            </div>
        </div>
        <div class="row form-group" style="margin-bottom:100px">
            <div class="col-md-12">
                <span  style="color: #337ab7;font-weight: 700;">Select attachments.</span>
            </div>
            <div class="col-md-12">
                <ob-checkbox :val="1" class="checkbox-style" v-model="ReportType.OnblickTimesheetReport">Onblick Timesheet report</ob-checkbox>
                <ob-checkbox :disabled="expenseCheckboxDisable" :val="1" class="checkbox-style" v-model="ReportType.ExpenseReport">Expense report</ob-checkbox>
                <span  class="ob-vuelidate_error-msg" v-if="IsSelectAtachemntError && IsButtonClicked">Please select</span>
            </div>
        </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="cancel()">Cancel</ob-button>
      <ob-button :disabled="!IsApprovedYimesheetsAvailable" @click="onShare()">Share</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
export default {
  props:["show","Month","Year"],
  data(){
    return {
        IsApprovedYimesheetsAvailable:true,
        expenseCheckboxDisable:false,
        ReportType:{
            OnblickTimesheetReport : true,
            ExpenseReport:true
        },
        TimesheetsList:[],
        showOptions :false,
        SelectedTimesheet:[],
        TimesheetListOptions: {
            data: [

            ],
            placeholder: {
                id: '-1',
                text: 'Please select'
            },
        },
        ShowSharePopup:false,

        IsSelectTimesheetError:false,
        IsSelectAtachemntError:false,
        IsButtonClicked:false
      }
  },
  created()
  {
    this.ShowSharePopup=this.show
  },
  computed: {
    SelectedEmpId()
    {
      return this.SelectedEmpList[0].id
    },
    SelectedEmpList()
    {
        return this.$store.getters.getManualRemainderEmpIds;
    },
    empNameList()
    {
        var empName = this.ManualRemainderEmpList.map(v=>v.name)

        let empString = empName.join("; ");

        if(empName.length > 20)
        {
            let count = empName.length - 20;
            empString +=  ` `+count+` More`
        }
        return empString
    },
    loggedInUserName() {
        return this.loggedInUserObj.Name ? this.loggedInUserObj.Name : this.loggedInUserObj.name ? this.loggedInUserObj.name : '';
    },
    subject()
    {
        return 'Timesheet Submission Reminder';
    }
  },
  watch: {
    show(val) {
      this.ShowSharePopup = val;
      if(val)
      {
          this.getTimesheetListForShare();
          this.resetData();
      }
    },
    ShowSharePopup(val) {
      this.$emit('update:show', val);
    },
    SelectedTimesheet(val)
    {
       if(val == null || val.length <= 0)
       {
          this.IsSelectTimesheetError = true;
       }
       else
       {
          this.IsSelectTimesheetError = false;
       }
    },
    ReportType:{
      handler: function (val, oldVal) {
        if(!val.ExpenseReport && !val.OnblickTimesheetReport)
        {
            this.IsSelectAtachemntError = true;
        }
        else
        {
            this.IsSelectAtachemntError = false;
        }
      },
      deep: true
    }
  },
  methods:{
    onShare()
    {
      this.IsButtonClicked = true;

       if(this.SelectedTimesheet != null && this.SelectedTimesheet.length >0)
       {
          if(!this.IsSelectTimesheetError && !this.IsSelectAtachemntError )
          {
              if(this.SelectedTimesheet.includes("All"))
              {
                this.SelectedTimesheet = this.TimesheetsList.map(v=>v.Id)
              }
              var selectedTimesheetList =  this.TimesheetsList.filter(v=>this.SelectedTimesheet.includes(v.Id));
              this.$parent.$parent.onShareTimesheetbuttonClick(selectedTimesheetList,this.ReportType);
          }
       }
    },
    resetData()
    {
        this.SelectedTimesheet = [];
        this.TimesheetListOptions = {
            data: [

            ],
            placeholder: {
                id: '-1',
                text: 'Please select'
            },
        };
        this.ReportType = {
            OnblickTimesheetReport : true,
            ExpenseReport:true
        };
        this.TimesheetsList = [];
        this.IsSelectTimesheetError = false;
        this.IsSelectAtachemntError = false;
        this.IsButtonClicked = false;
        this.expenseCheckboxDisable = false;
    },
    cancel(){
      window.bus.fire("UnselectEmployees");
      this.ShowSharePopup = false
    },
    onSelectTimesheet()
    {
        if(this.SelectedTimesheet != null && this.SelectedTimesheet.length >0)
        {
          if(this.SelectedTimesheet.includes("All"))
          {
            this.SelectedTimesheet = this.TimesheetsList.map(v=>v.Id)
          }

          var selectedTimesheetList =  this.TimesheetsList.filter(v=>this.SelectedTimesheet.includes(v.Id));

          var expenseReport = selectedTimesheetList.map(v=>v.ExpenseReportUrl);

          if(expenseReport.filter(v=>v != undefined && v != null && v != '').length <= 0)
          {
            this.expenseCheckboxDisable = true;
            this.ReportType.ExpenseReport = false;
          }
          else{
              this.expenseCheckboxDisable = false;
          }
        }
    },
    getTimesheetListForShare()
    {
          this.$loading({loadingText: 'Please wait...'});
          this.showOptions = false;
          ajax.get(`/TimeSheets/TimesheetListShareOptions?employeeId=${this.SelectedEmpId}&month=${this.Month}&year=${this.Year}`, {}, (res) => {
            if(res.data.State && res.data.TimesheetsShareOption.length > 0)
            {
                this.IsApprovedYimesheetsAvailable = true;

                this.TimesheetsList = res.data.TimesheetsShareOption;
                var data = __.map(this.TimesheetsList, (t) => {
                    return {
                    'id': t.Id,
                    'text': t.DateRange + ' ('+t.TotalHours+')',
                    'DateRange':t.DateRange,
                    'ProjectTitle':t.ProjectTitle,
                    'ClientOrganizationName':t.ClientOrganizationName,
                    'TotalHours':t.TotalHours,
                    'ReportUrl':t.ReportUrl,
                    'TimesheetReportUrl':t.TimesheetReportUrl,
                    'ExpenseReport':t.ExpenseReport
                    }
                })
                data.unshift({ id: 'All', text: 'All' ,
                    'DateRange':'',
                    'ProjectTitle':'',
                    'ClientOrganizationName':'',
                    'TotalHours':'',
                });
                this.TimesheetListOptions.data = data;
                var template = function(data) {

                   var result =`` ;
                   if(data.id == 'All')
                   {
                      result = `<div>${data.text} </div>`;
                   }
                   else
                   {

                      result = `<div>
                                    <div title="${data.text}" style="width:240px;display:inline-block;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">${data.text} &emsp;  </div>
                                    <div title="${data.ProjectTitle}" style="width:120px;display:inline-block;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">${data.ProjectTitle != null && data.ProjectTitle != ''? data.ProjectTitle : 'N/A'}    &emsp;  </div>
                                    <div  title="${data.ClientOrganizationName}" style="width:120px;display:inline-block;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">${data.ClientOrganizationName != null && data.ClientOrganizationName != ''? data.ClientOrganizationName : 'N/A'}    &emsp; </div>
                                    <div  title="${data.TotalHours}" style="width:65px;display:inline-block;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">${data.TotalHours}</div>
                                </div>`;
                   }
                    return $(result);
                }
                this.TimesheetListOptions.templateResult = template
                }
                else
                {
                  this.IsApprovedYimesheetsAvailable = false;
                }
                this.$loading({}).close();
                this.showOptions = true;
            })
    }
  },
}
</script>
<style>
 .validation-star{
    color: #F31D1D;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/ShareTimesheets.vue